export const DEFAULT_DASHBOARD_LAYOUT = [
  { id: "welcome_hero", colSpan: 4, rowHeight: 140, hidden: false },
  { id: "exhibitors", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "visitors", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "special_invitees", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "students", colSpan: 2, rowHeight: 140, hidden: false },

  // 2nd Row: App Modules Shortcuts Cards (6 cards in a single row)
  { id: "app_social_wall", colSpan: 2, rowHeight: 185, hidden: false },
  { id: "app_ufi_analytics", colSpan: 2, rowHeight: 185, hidden: false },
  { id: "app_event_catalogue", colSpan: 2, rowHeight: 185, hidden: false },
  { id: "app_onsite_module", colSpan: 2, rowHeight: 185, hidden: false },
  { id: "app_oes_analytics", colSpan: 2, rowHeight: 185, hidden: false },
  { id: "app_database", colSpan: 2, rowHeight: 185, hidden: false },

  { id: "trade_delegates", colSpan: 4, rowHeight: 140, hidden: false },
  { id: "countries_count", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "product_uploads", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "oes_submits", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "team_members", colSpan: 2, rowHeight: 140, hidden: false },
  { id: "monthwise_chart", colSpan: 6, rowHeight: 320, hidden: false },
  { id: "countrywise_chart", colSpan: 6, rowHeight: 320, hidden: false },
  { id: "statewise_chart", colSpan: 6, rowHeight: 320, hidden: false },
  { id: "designation_chart", colSpan: 6, rowHeight: 320, hidden: false },
  { id: "industry_sector_chart", colSpan: 6, rowHeight: 320, hidden: false },
  { id: "event_discovery_chart", colSpan: 6, rowHeight: 320, hidden: false },
];
